// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xH8R","label":"styles_label__1T9rt"};